import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import React, { useContext } from 'react';
import classNames from 'classnames';
import Sidebar from './sidebar';
import styles from './sidebar.module.scss';
import { NavSidebarMetaMenu } from '../../meta-menu';
import { SidebarHeader } from './sidebar-header';
import { getSideBarItems } from '../helpers/flatten-side-bar-groups';
import { getNavSideBarItemTransitionDelay } from '../helpers/get-nav-side-bar-item-transition-delay';
import { HeaderStateContext } from '../../../context/header-state-context';
import { Separator } from './separator';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var FirstLevelSideBar = function FirstLevelSideBar(_ref) {
  var sideBarGroups = _ref.sideBarGroups,
      showFirstLevel = _ref.showFirstLevel;

  var _useContext = useContext(HeaderStateContext),
      isNavDrawerOpen = _useContext.isNavDrawerOpen,
      closeNavDrawer = _useContext.closeNavDrawer,
      selectItem = _useContext.selectItem;

  var sideBarItems = getSideBarItems({
    items: sideBarGroups,
    selectItem: selectItem
  });
  var numberOfSideBarItems = sideBarItems.length;
  return /*#__PURE__*/_jsxs(Sidebar, {
    isSideBarOpen: isNavDrawerOpen,
    className: styles.sidebarAnimated,
    children: [/*#__PURE__*/_jsx(SidebarHeader, {
      onCloseClick: closeNavDrawer,
      children: "Menu"
    }), /*#__PURE__*/_jsxs("div", {
      className: classNames(styles.sidebarBody, _defineProperty({}, styles.open, showFirstLevel), 'px-300 h-100 d-flex flex-column'),
      children: [/*#__PURE__*/_jsx("ul", {
        role: "menu",
        className: "d-flex flex-column gap-300 py-400",
        children: sideBarItems
      }), /*#__PURE__*/_jsx(Separator, {
        className: "m-0",
        style: {
          transitionDelay: getNavSideBarItemTransitionDelay(numberOfSideBarItems++)
        }
      }), /*#__PURE__*/_jsx(NavSidebarMetaMenu, {
        className: styles.drawerItem,
        transitionDelayOffset: numberOfSideBarItems++
      })]
    })]
  });
};